import { memo, useRef, useState } from 'react';
import { TaskQueue } from '@djs';
import { useDidMount } from '@djs/react';

interface DeferredRenderProps {
  children: React.ReactNode;
  /** Показывать children без задержек.
   * Используется изначальное значение, изменение не влияет на отображение */
  immediate?: boolean;
}

/** Компонент для отложенного рендеринга.
 * Позволяет обработать рендеринг children в отдельной таске.
 * Полезно для разбития лонгтаски из-за большого колическтва обрабатываемых реакт-элементов
 * Задержка по умолчанию 12мс
 */
export const DeferredRender = memo(function DeferredRender(props: DeferredRenderProps) {
  const { children, immediate = false } = props;

  const [isRendered, setIsRendered] = useState(immediate);
  const isRenderedRef = useRef(false);
  isRenderedRef.current = isRendered;

  useDidMount(() => {
    if (isRenderedRef.current) {
      return;
    }

    let unmounted = false;

    TaskQueue.push(() => {
      if (!unmounted && !isRenderedRef.current) {
        setIsRendered(true);
      }
    });

    return () => {
      unmounted = true;
    };
  });

  if (immediate || isRendered) {
    return <>{children}</>;
  }

  return null;
});
